<template>
  <v-app class="app">
    <Menu v-if="showMenu"></Menu>
    <AppBar />
    <v-main>
      <v-container fluid>
        <router-view></router-view>
        <v-snackbar v-model="snck.snackbar" :color="snck.color" :timeout="snck.timeout">
          {{ snck.text }}
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Menu from "./components/Menu-organico.vue";
import AppBar from "./components/AppBar";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    AppBar,
    Menu,

  },
  computed: { ...mapGetters(["snackbar"]), ...mapGetters(["getLogged", "getUsuario"]) },
  watch: {
    snackbar() {
      this.snck = this.snackbar;
    },
    getUsuario(val) {
      if (val.isAdmin === 1) {
        this.showMenu = true;
      } else {
        this.showMenu = false;
      }
    },
  },
  data: () => ({
    snck: {},
    title: "DROPS",
    showMenu: false,
  }),
  methods: {
  },
  created() {
    document.title = this.title;
    let token = localStorage.getItem("SRV_VIDEOS");
    if (!token) return;
    if (token != "undefined" && token != "null") {
      this.$store.commit("setToken", token);
      this.$store.commit("setLogged", true);
    } else {
      if (!this.$route.path === "/login") {
        this.$router.push({ path: "/login" });
      }
    }
  },
};
</script>
<style>
.v-main,
.v-container {
  display: flex;
  flex-direction: column;
}

.v-main {
  min-height: calc(100vh - 64px);
}

.v-container {
  flex-grow: 1;
}

.menu {
  background: #005f36 !important;
  color: rgb(223, 223, 223) !important;
}

.titleCard {
  background: #005f36 !important;
  color: rgb(223, 223, 223) !important;
}

.v-field {
  background-color: #FFF !important;
}

.primary-card {
  background-color: #F5F5F5 !important;
}

.secondary-card {
  background-color: #EEEEEE !important;
}

.primary-card .v-card-title,
.secondary-card .v-card-title,
.third-card .v-card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #FFF !important;
  background-color: rgb(var(--v-theme-primary), 0.75);
}

.v-table,
.v-table th {
  background-color: transparent !important;
}

.app {
  /* background-image: ('@/assets/stv-background.png'); */
  background: url('@/assets/stv-background.png') no-repeat top fixed;
  background-size: cover;
}</style>